import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import { NavLink } from 'react-router';

function TopBar({ siteMeta }: { siteMeta: SiteMeta }) {
  return (
    <div className='topbar'>
      <div className='frame'>
        <NavLink
          to='/home/historian/data'
          className={({ isActive }) => `link ${isActive ? 'active' : ''}`}
        >
          <FormattedAlias id='Historian' />
        </NavLink>
        <NavLink
          to='/home/historian/archive'
          className={({ isActive }) => `link ${isActive ? 'active' : ''}`}
        >
          Archive
        </NavLink>
        {siteMeta.ui.Home_Historian_Export_Enable ? (
          <NavLink
            data-test='historian-export'
            to='/home/historian/export'
            className={({ isActive }) => `link ${isActive ? 'active' : ''}`}
          >
            <FormattedAlias id='Data Export' />
          </NavLink>
        ) : (
          ''
        )}
      </div>
      <div />
    </div>
  );
}

export default storeConnector(TopBar, {
  config: ['siteMeta'],
});
